import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import {
  ADD_CAPTAIN,
  CAMP,
  CAMP_ACCOUNT,
  CAMP_INSIGHTS,
  CAMP_KID_ACTIVITIES,
  CAMP_REASSIGN_KID,
  CAMP_TRIBE_ACTIVITIES,
  CAPTAIN_NOTES,
  EDIT_CAPTAIN,
  MY_SCHOOL_ROUTE,
  PARTNER_ADD_TREEHOUSE,
  PARTNER_EDIT_TREEHOUSE,
  SCHOOL_ADD_CHALLENGES,
  SCHOOL_CHALLENGES,
  SCHOOL_EDIT_CHALLENGES,
  SCHOOL_KIDS_ROUTE,
} from '../../../constants/routes.constants';
import CampChallenges from './CampChallenges';
import CampAddChallenge from './CampAddChallenge';
import CampEditChallenge from './CampEditChallenge';
import CampRoom from './CampRoom';
import CampKidSection from './CampKidSection';
import CampAddCaptain from './CampAddCaptain';
import CampEditCaptain from './CampEditCaptain';
import CampEditTribe from './CampEditTribe';
import CampAddTribe from './CampAddTribe';
import CheckEmail from './CheckEmail';
import CampCaptainNotes from './CampCaptainNotes';
import '../dashboard/css/guardian.settings.overview.scss';
import CampInsights from './CampInsights';
import CampAccountSettings from './CampAccountSettings';
import { RecoilRoot, useRecoilState } from 'recoil';
import CampReassignKid from './CampReassignKid';
import KidActivity from './kid_insights/KidActivity';
import TribeActivity from './tribe_activity/TribeActivity';
import { campTribesAtom, stepsEnabledAtom } from '../../../atoms/camp.atom';
import CampCaptainTour from './camp_tour/CampCaptainTour';
import CampTour from './camp_tour/CampTour';

const Tour = () => {
  const [campTribes, setCampTribes] = useRecoilState(campTribesAtom);
  const [stepsEnabled, setStepsEnabled] = useRecoilState(stepsEnabledAtom);
  const { school } = useAuth();

  return (
    <>
      {school.user_type === 'school_teacher' && stepsEnabled && (
        <CampCaptainTour tribesList={campTribes || []} />
      )}
      {school.user_type === 'school' && stepsEnabled && (
        <CampTour tribesList={campTribes || []} />
      )}
    </>
  );
};

const CampDashboard = () => {
  return (
    <div className="dashboard-wrapper">
      <div>
        <Switch>
          <RecoilRoot>
            <Tour />
            <Route exact path={`${CAMP}/check-email`} component={CheckEmail} />
            <Route exact path={SCHOOL_CHALLENGES} component={CampChallenges} />
            <Route
              exact
              path={SCHOOL_ADD_CHALLENGES}
              component={CampAddChallenge}
            />
            <Route
              exact
              path={SCHOOL_EDIT_CHALLENGES}
              component={CampEditChallenge}
            />
            <Route exact path={MY_SCHOOL_ROUTE} component={CampRoom} />
            <Route exact path={SCHOOL_KIDS_ROUTE} component={CampKidSection} />
            <Route
              exact
              path={PARTNER_ADD_TREEHOUSE}
              component={CampAddTribe}
            />
            <Route
              exact
              path={PARTNER_EDIT_TREEHOUSE}
              component={CampEditTribe}
            />
            <Route exact path={ADD_CAPTAIN} component={CampAddCaptain} />
            <Route exact path={EDIT_CAPTAIN} component={CampEditCaptain} />
            <Route exact path={CAPTAIN_NOTES} component={CampCaptainNotes} />
            <Route exact path={CAMP_INSIGHTS} component={CampInsights} />
            <Route exact path={CAMP_ACCOUNT} component={CampAccountSettings} />
            <Route exact path={CAMP_REASSIGN_KID} component={CampReassignKid} />
            <Route exact path={CAMP_KID_ACTIVITIES} component={KidActivity} />
            <Route
              exact
              path={CAMP_TRIBE_ACTIVITIES}
              component={TribeActivity}
            />
            {/* <Route render={() => <Redirect to={{ pathname: SCHOOL_LOGIN }} />} /> */}
          </RecoilRoot>
        </Switch>
      </div>
    </div>
  );
};

export default CampDashboard;